import {FlowStatePresentation} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStatePresentation";
import {FlowStateController} from "@nolimitcity/slot-game/bin/flowcontrol/FlowStateController";
import {TimelineLite} from "gsap";
import {DumpsterFire} from "../../DumpsterFire";
import {DFGameConfig} from "../../DFGameConfig";
import {APISetting} from "@nolimitcity/slot-launcher/bin/interfaces/APISettingsSystem";
import {DumpsterFireGameMode} from "../../server/DumpsterFireGameMode";
import {BetFeature} from "@nolimitcity/slot-launcher/bin/plugins/apiplugin/bethandler/BetFeatureController";
import {DumpsterFireSound} from "../../sound/DumpsterFireSound";

export class DumpsterFireNormalBetPresentation implements FlowStatePresentation {

    constructor() {

    }

    public start(flowStateController: FlowStateController) {
        const tl: TimelineLite = new TimelineLite(
                {
                    onComplete: () => {
                        DumpsterFire.model.inActionSpin = false;
                        flowStateController.finish();
                    }
                }
            ),
            delay: number = DumpsterFire.apiPlugin.settings.get(APISetting.FAST_SPIN, false) ? DFGameConfig.reelAllOutStopDelayFastSpin : DFGameConfig.reelAllOutStopDelay;
        DumpsterFire.model.multiOnXIArray.length = 0;
        DumpsterFire.model.hitMaxMulti.length = 0;
        DumpsterFire.model.scatterSymArray = [];
        if (DumpsterFire.model.data.upgradedSymbols.length > 0) {
            DumpsterFire.transitionView.removeTransitionAnim();
        }
        const activeBetFeature: BetFeature | undefined = DumpsterFire.apiPlugin.betFeatureController.getActiveBetFeature();
        if (((DumpsterFire.model.data.mode.indexOf("NORMAL") > -1 || DumpsterFire.model.data.mode.indexOf("EXTRA_SPIN") > -1||DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1) && !(DumpsterFire.model.data.nextMode.indexOf("FREESPIN") > -1) && DumpsterFire.model.data.upgradedSymbols.length === 0) ||
            ((DumpsterFire.model.data.mode.indexOf("EXTRA_SPIN") > -1 || DumpsterFire.model.data.mode.indexOf("FREESPIN") > -1) && DumpsterFire.model.data.nextMode.indexOf("NORMAL") > -1 && DumpsterFire.model.data.upgradedSymbols.length > 0)) {
            DumpsterFire.backgroundElements.resetIdleTimeline();
            if (activeBetFeature?.name === "BOOSTED_BET_STATE_2" || activeBetFeature?.name === "BOOSTED_BET_STATE_64" || activeBetFeature?.name === "BOOSTED_BET_STATE_1024") {
                if (DumpsterFire.model.isNotNoWinRound || DumpsterFire.model.isBBChanged || DumpsterFire.model.boostedBetName === "" || DumpsterFire.model.inActionSpin) {
                    tl.add([
                        DumpsterFire.bgMulti.removeMulti(),
                        DumpsterFire.bgFinalMulti.removeFinalMulti(),
                        () => {
                            DumpsterFire.fireFrame.removeAllSpines();
                            DumpsterFire.backgroundElements.removeFrameLoop();
                            DumpsterFire.allReelsView.removeAllMulti()
                            DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
                        }], 0);
                }
            } else {
                DumpsterFire.model.boostedBetName = "";
                tl.add([
                    DumpsterFire.bgMulti.removeMulti(),
                    DumpsterFire.bgFinalMulti.removeFinalMulti(),
                    () => {
                        DumpsterFire.fireFrame.removeAllSpines();
                        DumpsterFire.backgroundElements.removeFrameLoop();
                        DumpsterFire.allReelsView.removeWinMulti()
                        DumpsterFire.soundPlayer.stopSound(DumpsterFireSound.MULTI_FIRE);
                    }], 0);
            }
            DumpsterFire.soundPlayer._currentMulti = 2;
            tl.add(DumpsterFire.allReelsView.addBBInitialMulti(), ">");
        }
        tl.add(DumpsterFire.allReelsView.mainReelModels[0].start(), 0);
        tl.add(DumpsterFire.allReelsView.mainReelModels[1].start(), delay);
        tl.add(DumpsterFire.allReelsView.mainReelModels[2].start(), delay * 2);
        tl.add(DumpsterFire.allReelsView.mainReelModels[3].start(), delay * 3);
        tl.add(DumpsterFire.allReelsView.mainReelModels[4].start(), delay * 4);
        tl.add(DumpsterFire.allReelsView.mainReelModels[5].start(), delay * 5);
    }
}